export default class OhsQrCodeFilterModels {
  view1QrCodeList: {
    viewPreset: 'view_1';
    archived?: boolean;
  };

  view2QrCodeList: {
    viewPreset: 'view_2';
    archived?: boolean;
  };

  sort: string;

  tableSortKeyLists: {
    sortColAscDescOptions: { name: string; value: string }[];
  };

  constructor() {
    this.view1QrCodeList = {
      viewPreset: 'view_1',
      archived: false,
    };
    this.view2QrCodeList = {
      viewPreset: 'view_2',
      archived: false,
    };
    this.sort = '{ "key": "_id", "order": -1 }';
    this.tableSortKeyLists = {
      sortColAscDescOptions: [
        { name: 'Created Order: Newest to Oldest', value: '{ "key": "_id", "order": -1 }' },
        { name: 'Created Order: Oldest to Newest', value: '{ "key": "_id", "order": 1 }' },
      ],
    };
  }
}
